// Punto de entrada único para todos los servicios de datos.
// Cuando REACT_APP_USE_MOCK=true, usa datos en memoria (mockApi).
// Cuando REACT_APP_USE_MOCK=false, usa el backend real (api.js).

import * as mockApi from './mockApi';
import * as realApi from './api';
import { USE_MOCK } from './supabaseClient';

// USE_MOCK es true SOLO si no hay credenciales de Supabase configuradas.
// Si Supabase está configurado, siempre usamos el backend real.
const svc = USE_MOCK ? mockApi : realApi;

// — Auth —
export const login     = (...a) => svc.login(...a);
export const register  = (...a) => svc.register(...a);
export const verifyOtp = (...a) => svc.verifyOtp(...a);
export const resendOtp = (...a) => svc.resendOtp(...a);
export const getMyRole = (...a) => svc.getMyRole?.(...a) ?? Promise.resolve(null);
// Rol + overrides de permisos del usuario en el negocio actual (0049).
export const getMisPermisos = (...a) => svc.getMisPermisos?.(...a) ?? Promise.resolve({ rol: null, overrides: {}, permisos: null, permisosRoles: null });
// Permisos POR ROL del negocio (businesses.permisos_roles, 0052): leer / guardar (solo admin).
export const getPermisosRoles     = (...a) => svc.getPermisosRoles?.(...a) ?? Promise.resolve({});
export const guardarPermisosRoles = (...a) => svc.guardarPermisosRoles?.(...a) ?? Promise.reject(new Error('not_supported'));

// — Negocio —
export const getNegocio    = (...a) => svc.getNegocio(...a);
export const createNegocio = (...a) => svc.createNegocio(...a);
export const updateNegocio = (...a) => svc.updateNegocio(...a);
export const uploadLogoNegocio = (...a) => svc.uploadLogoNegocio?.(...a);
export const uploadMenuPdf     = (...a) => svc.uploadMenuPdf?.(...a);
export const uploadMenuHeader  = (...a) => svc.uploadMenuHeader?.(...a);
// Foto de producto: subir archivo propio o sugerencias automáticas (Pexels)
export const uploadImagenProducto = (...a) => svc.uploadImagenProducto?.(...a);
export const sugerirImagenes      = (...a) => svc.sugerirImagenes?.(...a) ?? Promise.resolve([]);
export const trackMenuView     = (...a) => svc.trackMenuView?.(...a);
export const subirEvidenciaVenta = (...a) => svc.subirEvidenciaVenta?.(...a);
export const urlEvidenciaVenta   = (...a) => svc.urlEvidenciaVenta?.(...a);
export const subirAvatarEmpleado = (...a) => svc.subirAvatarEmpleado?.(...a);

// — Productos —
export const getProductos   = (...a) => svc.getProductos(...a);
export const createProducto = (...a) => svc.createProducto(...a);
export const updateProducto = (...a) => svc.updateProducto(...a);
export const deleteProducto = (...a) => svc.deleteProducto(...a);

// — Categorías —
export const getCategorias   = (...a) => svc.getCategorias(...a);
export const createCategoria = (...a) => svc.createCategoria(...a);
export const updateCategoria = (...a) => svc.updateCategoria(...a);
export const deleteCategoria = (...a) => svc.deleteCategoria(...a);

// — Mesas —
export const getMesas    = (...a) => svc.getMesas(...a);
export const createMesa  = (...a) => svc.createMesa(...a);
export const deleteMesa  = (...a) => svc.deleteMesa(...a);
export const updateMesa  = (...a) => svc.updateMesa(...a);
export const cambiarMesa = (...a) => svc.cambiarMesa(...a);

// — Cuentas —
export const getCuentas   = (...a) => svc.getCuentas(...a);
export const createCuenta = (...a) => svc.createCuenta(...a);
export const updateCuenta = (...a) => svc.updateCuenta(...a);
export const getCuenta    = (...a) => svc.getCuenta(...a);

// — Órdenes (flujo de 3 pasos) —
export const getOrdenes              = (...a) => svc.getOrdenes(...a);
export const createOrden             = (...a) => svc.createOrden(...a);
export const deliverOrden            = (...a) => svc.deliverOrden(...a);
export const createVenta             = (...a) => svc.createVenta(...a);
export const updateOrden             = (...a) => svc.updateOrden(...a);
// Modo offline (Fase 2): cobro sin internet con reenvío idempotente.
export const crearVentaDirecta        = (...a) => svc.crearVentaDirecta?.(...a) ?? Promise.reject(new Error('not_supported'));
export const encolarVentaOffline      = (...a) => svc.encolarVentaOffline?.(...a) ?? null;
export const ventasOfflinePendientes  = (...a) => svc.ventasOfflinePendientes?.(...a) ?? [];
export const contarVentasOffline      = (...a) => svc.contarVentasOffline?.(...a) ?? 0;
export const sincronizarVentasOffline = (...a) => svc.sincronizarVentasOffline?.(...a) ?? Promise.resolve({ ok: 0, fail: 0 });
export const emitirFacturaDian         = (...a) => svc.emitirFacturaDian?.(...a);
export { onColaCambio } from './colaOffline';
// Para el flujo "tomar pedido en la mesa → cocina sin cobrar"
export const getOrdenAbiertaPorMesa  = (...a) => svc.getOrdenAbiertaPorMesa?.(...a) ?? Promise.resolve(null);
export const enviarPedidoMesa        = (...a) => svc.enviarPedidoMesa?.(...a) ?? Promise.reject(new Error('not_supported'));
// Para "liberar mesa con orden activa" y "quitar producto desde el panel mesa"
export const cancelarOrden           = (...a) => svc.cancelarOrden?.(...a) ?? Promise.resolve(null);
export const quitarLineaOrden        = (...a) => svc.quitarLineaOrden?.(...a) ?? Promise.reject(new Error('not_supported'));

// — Empleados —
export const getEmpleados   = (...a) => svc.getEmpleados(...a);
export const createEmpleado = (...a) => svc.createEmpleado(...a);
export const updateEmpleado = (...a) => svc.updateEmpleado(...a);
// PIN de empleados hasheado (0053): estado y fijar/borrar.
export const getEstadoPines  = (...a) => svc.getEstadoPines(...a);
export const setPinEmpleado  = (...a) => svc.setPinEmpleado(...a);
export const deleteEmpleado = (...a) => svc.deleteEmpleado(...a);

// — Movimientos —
export const getMovimientos   = (...a) => svc.getMovimientos(...a);
export const createMovimiento = (...a) => svc.createMovimiento(...a);

// — Inventario maestro (0051): carga masiva, kardex y cobertura de recetas —
export const cargarInventarioMaestro = (...a) => svc.cargarInventarioMaestro?.(...a) ?? Promise.resolve({ creados: 0, actualizados: 0, sinCambio: 0, errores: [] });
export const getKardexInventario     = (...a) => svc.getKardexInventario?.(...a) ?? Promise.resolve([]);
export const getCoberturaRecetas     = (...a) => svc.getCoberturaRecetas?.(...a) ?? Promise.resolve({ totalProductos: 0, conReceta: 0, sinReceta: [] });

// — Turnos —
export const getTurnoActivo            = (...a) => svc.getTurnoActivo(...a);
export const createTurno               = (...a) => svc.createTurno(...a);
export const updateTurno               = (...a) => svc.updateTurno(...a);
export const iniciarTurnoEmpleado      = (...a) => svc.iniciarTurnoEmpleado?.(...a);
export const finalizarTurnoEmpleado    = (...a) => svc.finalizarTurnoEmpleado?.(...a);
export const listarTurnosMes           = (...a) => svc.listarTurnosMes?.(...a) ?? Promise.resolve([]);
// Asistencia con evidencia: foto + GPS (0050) — /mi-turno y Configuración → Asistencia
export const listarUltimosTurnos       = (...a) => svc.listarUltimosTurnos?.(...a) ?? Promise.resolve([]);
export const getMiEmpleado             = (...a) => svc.getMiEmpleado?.(...a) ?? Promise.resolve(null);
// ─ Checklist de turnos + Llave del local (0058) ─
export const guardarChecklistConfig   = (...a) => svc.guardarChecklistConfig(...a);
export const guardarMetodosPago       = (...a) => svc.guardarMetodosPago?.(...a) ?? Promise.reject(new Error('not_supported'));
// Descuentos con autorización (0067)
export const guardarDescuentosConfig  = (...a) => svc.guardarDescuentosConfig?.(...a) ?? Promise.reject(new Error('not_supported'));
export const verificarPinEmpleado     = (...a) => svc.verificarPinEmpleado?.(...a) ?? Promise.reject(new Error('not_supported'));
// Propinas repartidas (0067)
export const getPropinasResumen       = (...a) => svc.getPropinasResumen?.(...a) ?? Promise.reject(new Error('not_supported'));
export const repartirPropinas         = (...a) => svc.repartirPropinas?.(...a) ?? Promise.reject(new Error('not_supported'));
export const listarRepartosPropinas   = (...a) => svc.listarRepartosPropinas?.(...a) ?? Promise.resolve([]);
export const misPropinas              = (...a) => svc.misPropinas?.(...a) ?? Promise.resolve({ total_30d: 0, total_90d: 0, repartos: [] });
export const anularRepartoPropinas    = (...a) => svc.anularRepartoPropinas?.(...a) ?? Promise.reject(new Error('not_supported'));
export const vincularClienteVenta     = (...a) => svc.vincularClienteVenta?.(...a) ?? Promise.resolve(false);
export const registrarChecklist       = (...a) => svc.registrarChecklist(...a);
export const getRegistrosChecklist    = (...a) => svc.getRegistrosChecklist?.(...a) ?? Promise.resolve([]);
export const activarLlaveAsistencia   = (...a) => svc.activarLlaveAsistencia(...a);
export const getLlaveActual           = (...a) => svc.getLlaveActual?.(...a) ?? Promise.resolve(null);
export const canjearLlaveAsistencia   = (...a) => svc.canjearLlaveAsistencia?.(...a) ?? Promise.resolve({ ok: true });
export const subirFotoAsistencia       = (...a) => svc.subirFotoAsistencia?.(...a) ?? Promise.resolve(null);
export const urlFotoAsistencia         = (...a) => svc.urlFotoAsistencia?.(...a) ?? Promise.resolve(null);
export const getUbicacionNegocio       = (...a) => svc.getUbicacionNegocio?.(...a) ?? Promise.resolve({ lat: null, lng: null, radioM: 150, requiereFoto: false, requiereGps: false, persistido: false });
export const guardarUbicacionNegocio   = (...a) => svc.guardarUbicacionNegocio?.(...a) ?? Promise.reject(new Error('not_supported'));

// — Ventas cerradas (tabla sales: plata real que entró a la caja) —
export const getVentas       = (...a) => svc.getVentas?.(...a) ?? Promise.resolve([]);

// — Reportes —
export const getKPIs         = (...a) => svc.getKPIs(...a);
export const getVentasPorDia = (...a) => svc.getVentasPorDia(...a);

// — Zonas —
export const getZonas    = (...a) => svc.getZonas(...a);
export const createZona  = (...a) => svc.createZona(...a);
export const updateZona  = (...a) => svc.updateZona(...a);
export const deleteZona  = (...a) => svc.deleteZona(...a);

// — Fidelidad / Lealtad —
export const getCliente              = (...a) => svc.getCliente(...a);
export const buscarClientes          = (...a) => svc.buscarClientes?.(...a) ?? Promise.resolve([]);
export const registrarVisita         = (...a) => svc.registrarVisita(...a);
export const listarClientesFrecuentes = (...a) => svc.listarClientesFrecuentes?.(...a) ?? Promise.resolve([]);
export const getRecompensas          = (...a) => svc.getRecompensas?.(...a) ?? Promise.resolve([]);
export const crearRecompensa         = (...a) => svc.crearRecompensa?.(...a);
export const actualizarRecompensa    = (...a) => svc.actualizarRecompensa?.(...a);
export const eliminarRecompensa      = (...a) => svc.eliminarRecompensa?.(...a);
export const canjearRecompensa       = (...a) => svc.canjearRecompensa?.(...a);
export const historialCanjes         = (...a) => svc.historialCanjes?.(...a) ?? Promise.resolve([]);

// — Promociones / Happy Hour —
export {
  listarPromociones,
  crearPromocion,
  actualizarPromocion,
  eliminarPromocion,
  togglePromocion,
  precioConPromo,
  promocionesService,
} from './promocionesService';

// — Estado del día —
export const getDiaActivo        = (...a) => svc.getDiaActivo(...a);
export const abrirDia            = (...a) => svc.abrirDia(...a);
export const cerrarDia           = (...a) => svc.cerrarDia(...a);
export const getHistoricoArqueos = (...a) => svc.getHistoricoArqueos(...a);

// — Planes y pagos —
export {
  obtenerEstadoPlan,
  activarDemoPro,
  solicitarDemo,
  miCodigoReferido,
  registrarReferido,
  iniciarPagoWompi,
  listarPagos,
  obtenerLinkWompi,
  wompiEstaConectado,
} from './planesService';

// — CRM de TemeT (super admins; guardas MOCK_DEV propias, ver crmService) —
export {
  crmResumen, crmNegocios, crmLeads, crmCuenta,
  TIPOS_NOTA_CRM, crmAgregarNota, crmEliminarNota,
  crmActivarPlan, crmOtorgarReferido, crmSetStatus, crmEliminarNegocio, crmRestaurarNegocio,
  crmQuitarRestricciones, crmResolverSolicitud, crmSetNota, crmUpdateNegocio, crmCrearNegocio,
  crmEnviarLinkAcceso, crmEnviarComunicado,
} from './crmService';
